<span class="chip" [class.chip-highlighted]="variant() === 'highlighted'" [class.chip-primary]="color() === 'primary'"
  [class.chip-accent]="color() === 'accent'" [class.chip-success]="color() === 'success'"
  [class.chip-warning]="color() === 'warning'" [class.chip-danger]="color() === 'danger'">
  <ng-content></ng-content>
</span>